import React from 'react';
import { Flex } from '../UI-CHAKRA/Flex';
import { Text } from '../UI-CHAKRA/Text';
import { ReactComponent as AlertIcon } from '../../assets/images/result_not_found.svg';
import { ReactComponent as PlusIcon } from '../../assets/images/icons/mevo/plus.svg';
import { Box } from '../UI-CHAKRA/Box';
import { BsPlusCircle } from 'react-icons/bs';
import { Button } from '../UI-CHAKRA/Button';
import { truncate } from 'lodash';
import { SEARCH_TYPE } from './SearchTypeEnum';

interface ResultsNotFoundProps {
  searchType: SEARCH_TYPE;
  showIncludeManualMedicine: boolean;
  onSelectManualMedicineSearch(): void;
  searchValue: string;
  mandatoryRemumeSearch: boolean;
  openFormulaFormDialog?: () => void;
}

export default function ResultsNotFound(props: ResultsNotFoundProps) {
  return (
    <Box>
      <Flex p={'20px'} alignItems={'center'} justifyContent={'center'}>
        <Flex mr={'20px'} className="float-container">
          <AlertIcon width={'110px'} />
        </Flex>
        <Flex flexDirection={'column'} gap={'10px'} alignItems={'flex-start'}>
          <Text fontWeight={700} fontSize={'16px'} color={'typography.dark'} lineHeight={'17px'} mb={'5px'}>
            Resultado não encontrado
          </Text>

          {props.searchType === SEARCH_TYPE.FORMULA && (
            <Flex flexDirection={'column'} gap={'10px'} alignItems={'flex-start'}>
              <Text fontWeight={400} fontSize={'14px'} color={'#868E96'} lineHeight={'17px'} mb={'5px'}>
                Refaça sua busca ou crie uma nova fórmula por meio <br /> do botão abaixo
              </Text>
              <Button
                bg={'transparent'}
                color={'primary.main'}
                border={'2px solid'}
                borderColor={'primary.main'}
                borderRadius={'48px'}
                padding={'0 12px'}
                display={'flex'}
                alignItems={'center'}
                gap={'8px'}
                onClick={props.openFormulaFormDialog}
              >
                <PlusIcon />
                Prescrever fórmula
              </Button>
            </Flex>
          )}

          {props.searchType === SEARCH_TYPE.MEDICINE && (
            <Box w={{ base: '100%', md: '300px' }}>
              <Text
                mb={'5px'}
                fontWeight={700}
                fontSize={'12px'}
                color={'#545C62'}
                textAlign={'left'}
                lineHeight={'13px'}
              >
                {props.mandatoryRemumeSearch
                  ? 'Devido à solicitação da Secretaria Municipal da Saúde da Prefeitura de São Paulo, serão exibidos como resultado apenas os medicamentos contidos na Relação Municipal de Medicamentos Essenciais (Remume) de São Paulo - SP.'
                  : 'Refaça sua busca ou crie um medicamento manual no botão abaixo'}
              </Text>

              {props.showIncludeManualMedicine && !props.mandatoryRemumeSearch && (
                <Button
                  onClick={props.onSelectManualMedicineSearch}
                  variant={'ghost'}
                  leftIcon={<BsPlusCircle color={'#3484FA'} />}
                  fontSize={'12px'}
                  borderRadius={'20px'}
                  backgroundColor={'gray.lightest'}
                  _hover={{
                    backgroundColor: 'gray.light',
                  }}
                  mt={'5px'}
                  p={'8px 8px 8px 12px'}
                  h={'30px'}
                >
                  medicamento manual
                  <Text ml={'5px'} as={'span'}>
                    "{truncate(props.searchValue, { length: 10 })}"
                  </Text>
                </Button>
              )}
            </Box>
          )}
        </Flex>
      </Flex>
    </Box>
  );
}
